/**
 * Provides custom easing functions for Reel Behavior.
 * https://easings.net/ sours for adding more easing functions if needed
 */

export function DoubleBounce(p:number) {
    if (p < .7) {
        return p * p * 2.0408;
    }
    else if (p < 1) {
        return 2.222 * p * p - 3.778 * p + 2.556;
    }
    return 1;
};

export function Cubic(p:number) {
    return 1 - Math.pow(1 - p, 2);
};

 // Three Points Parabola
export function OutBack(p:number) {
    return -(25 / 16) * p * p + (41 / 16) * p;
};

export function  EaseOutQuad(x: number): number {
    return 1 - (1 - x) * (1 - x);
}

export function  EaseOutBack(x: number): number {
    const c1 = 1.70158;
    const c3 = c1 + 1;
    return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
}

export function  EaseInOutBack(x: number): number {
    const c1 = 1.70158;
    const c2 = c1 * 1.525;
    return x < 0.5
      ? (Math.pow(2 * x, 2) * ((c2 + 1) * 2 * x - c2)) / 2
      : (Math.pow(2 * x - 2, 2) * ((c2 + 1) * (x * 2 - 2) + c2) + 2) / 2;
}

export function  EaseOutSine(x: number): number {
    return Math.sin((x * Math.PI) / 2);
  }
